import { authState } from "@app/store/authStore.svelte.js";
import { query, where, getDocs, doc, setDoc, Timestamp } from "firebase/firestore";

export const TRIAL_JOB_LIMIT = 5;
export const TRIAL_LIMIT_MESSAGE = "Trial Limit Reached";

const COUNTABLE_STATUSES = ["Submitted", "In Progress", "Passed", "Processing"];

export function isTrialUser() {
    return authState.status === "in_trial";
}

export async function countActiveTrialJobs(homeRef, type, excludeJobId) {
    const snapshot = await getDocs(query(homeRef, where("type", "==", type)));
    return snapshot.docs.filter((jobDoc) => {
        if (excludeJobId && jobDoc.id === excludeJobId) {
            return false;
        }
        const data = jobDoc.data();
        if (data.deleted) {
            return false;
        }
        return COUNTABLE_STATUSES.includes(data.status);
    }).length;
}

export async function getTrialJobSlotsRemaining(homeRef, type) {
    if (!isTrialUser()) {
        return Number.POSITIVE_INFINITY;
    }
    const count = await countActiveTrialJobs(homeRef, type);
    return Math.max(0, TRIAL_JOB_LIMIT - count);
}

export async function writeTrialLimitJob(homeRef, jobInfo) {
    const now = Timestamp.fromDate(new Date());
    await setDoc(doc(homeRef, jobInfo.id), {
        ...jobInfo,
        status: "Failed",
        statusMsg: TRIAL_LIMIT_MESSAGE,
        progress: 100,
        completedOn: now,
        updatedOn: now,
    });
}
